// extracted by mini-css-extract-plugin
export default {"container":"FormDropdown_container__T9N5+","list":"FormDropdown_list__oTThh"};